import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { BrowserRouter } from "react-router-dom";
import Header from "./components/Header.jsx";
import { AuthProvider } from "./utils/auth-context.tsx";
import { ThemeProvider } from "./utils/theme-context.tsx";
import { VideosProvider } from "./utils/video-context.jsx";
import * as Sentry from "@sentry/react";
import "@assets/scss/main.scss";
import Footer from "@components/Footer.jsx";

Sentry.init({
  dsn: "https://cc8f4ab1feba3e5b5d3397ea57f56d75@o4508846402568192.ingest.us.sentry.io/4508846403682304",
  debug: true,
  tracesSampleRate: 1.0,
});

createRoot(document.getElementById("root")).render(
  <Sentry.ErrorBoundary fallback={"Произошла ошибка"}>
    <StrictMode>
      <AuthProvider>
        <VideosProvider>
          <ThemeProvider>
            <BrowserRouter>
              <div className={`main-layout`}>
                <Header />
                <main style={{ flexGrow: 1 }}>
                  <App />
                </main>
                <Footer />
              </div>
            </BrowserRouter>
          </ThemeProvider>
        </VideosProvider>
      </AuthProvider>
    </StrictMode>
  </Sentry.ErrorBoundary>,
);
